export enum SurveyCycleStatus {
  OPEN = 'Open',
  CLOSE = 'Close',
}
